import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Envs } from '../envs'
import { GetUpgradeStateOutput } from '../domain/dtos/get-upgrade-state-output'

export class GetUpgradeState {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(subscriptionId?: string): Promise<GetUpgradeStateOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_WEB_URL}/pay/upgrade-state`,
      params: { subscriptionId },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new Error('Erro ao buscar status do upgrade')
  }
}
